import { SUBJECT_TYPE } from '../proposalrequest';
import { COMPANY_STATUS } from '../companies';

const PROCEDURE_TYPES = {
  CHANGE_COMPANY_NAME: 'CHANGE_COMPANY_NAME',
  CHANGE_CORPORATE_PURPOSE: 'CHANGE_CORPORATE_PURPOSE',
  CHANGE_REGISTERED_OFFICE: 'CHANGE_REGISTERED_OFFICE',
  CHANGE_ESTABLISHMENTS: 'CHANGE_ESTABLISHMENTS',
  CHANGE_PARTNER: 'CHANGE_PARTNER',
  CHANGE_ADMINISTRATION_CONTROL_BODY: 'CHANGE_ADMINISTRATION_CONTROL_BODY',
  NOTARIAL_PROCEDURE: 'NOTARIAL_PROCEDURE',
  COMPANY_DISSOLUTION: 'COMPANY_DISSOLUTION',
  CHANGE_STATE_OTHER_ACTIVITIES: 'CHANGE_STATE_OTHER_ACTIVITIES',
  TCP_UPDATE_CORPORATE_PURPOSE: 'TCP_UPDATE_CORPORATE_PURPOSE',
  TCP_UPDATE_ESTABLISHMENTS: 'TCP_UPDATE_ESTABLISHMENTS',
  TCP_UPDATE_REGISTERED_ADDRESS: 'TCP_UPDATE_REGISTERED_ADDRESS',
  TCP_UPDATE_REPRESENTATIVES: 'TCP_UPDATE_REPRESENTATIVES',
  TCP_UPDATE_GENERAL_INFO: 'TCP_UPDATE_GENERAL_INFO',
  TCP_UPDATE_SOCIAL_CONTRIBUTION: 'TCP_UPDATE_SOCIAL_CONTRIBUTION',
  TCP_SUSPENSION_OF_ACTIVITIES: 'TCP_SUSPENSION_OF_ACTIVITIES',
  TCP_REACTIVATION_OF_ACTIVITIES: 'TCP_REACTIVATION_OF_ACTIVITIES',
  TCP_CANCELLATION: 'TCP_CANCELLATION',
};

const PROCEDURE_TYPES_ENUM = Object.keys(PROCEDURE_TYPES);

const getProcedureTypesBySubjectType = (subjectType) => {
  const isStatePyme = [SUBJECT_TYPE.STATE_MIPYME, SUBJECT_TYPE.ORGANIZATION_PMS].includes(subjectType);

  return PROCEDURE_TYPES_ENUM
    .filter((e) => {
      const isTCPItem = e?.startsWith('TCP_');
      if (subjectType === SUBJECT_TYPE.TCP_PROPOSAL) return isTCPItem;
      if (!isStatePyme) return !isTCPItem && e !== PROCEDURE_TYPES.CHANGE_STATE_OTHER_ACTIVITIES;
      return !isTCPItem;
    });
};

const getProcedureTypesBySubjectTypeAndStatus = (subjectType, status) => getProcedureTypesBySubjectType(subjectType)
  .filter((e) => {
    if (status === COMPANY_STATUS.ON_DISSOLVE_PROCESS) return e === PROCEDURE_TYPES.COMPANY_DISSOLUTION;
    return true;
  });

export {
  PROCEDURE_TYPES_ENUM,
  PROCEDURE_TYPES,
  getProcedureTypesBySubjectType,
  getProcedureTypesBySubjectTypeAndStatus,
};
